import "./Modal.css";

import grap from "../../assets/images/training-two.jpg";
// import digital from "../../assets/images/digital.jpeg";
import Button from "react-bootstrap/Button";
import { NavLink } from "react-router-dom";
const Coursesmodal = ({ showModal, closeModal }) => {
  if (!showModal) {
    return null; // If showModal is false, return nothing
  }

  return (
    <div className="modal-overlay-m" onClick={closeModal}>
      <div
        className="modal-content-course"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={closeModal} className="remove-course">
          &#10006;
        </button>

        <div className="image-container">
          <img src={grap} alt="courses" />
        </div>
        {/* <div className="image-container">
          <img src={digital} alt="courses" />
        </div> */}
        <NavLink
          exact
          to="/training"
        >
          <Button className="btn btn-regis">বিস্তারিত</Button>
        </NavLink>

        {/* <NavLink exact to="/">
          <Button className='btn btn-regis'>Appointment</Button>
          </NavLink> */}
      </div>
    </div>
  );
};

export default Coursesmodal;
